// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import color from "@hardwoods/XDL/Utilities/color";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export const dashboardWidgetWrapper: InjectableCss = {
    css: css`
        border-color: ${color("common.brand1")} ${color("common.border")} ${color("common.border")};
        border-style: solid;
        border-width: 8px 1px 1px;
        padding: 0 20px 20px;
        border-radius: 4px;
        width: 100%;
        box-shadow: 0 0 15px 0 rgb(150 150 150 / 15%);
    `,
};
